var _defs, _rect, _rect2, _circle, _path, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoThumbPlaceholder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 320,
    height: 180,
    viewBox: "0 0 320 180",
    role: "img",
    "aria-label": "Video thumbnail placeholder",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "vbg",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#d964e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#e88af0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f25a94"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 180,
    rx: 12,
    fill: "url(#vbg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 296,
    height: 156,
    rx: 8,
    fill: "rgba(255,255,255,0.08)",
    stroke: "rgba(255,255,255,0.2)",
    strokeWidth: 1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 88,
    r: 26,
    fill: "rgba(255,255,255,0.22)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150 74 L150 102 L178 88 Z",
    fill: "#fffdf8"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 160,
    y: 148,
    textAnchor: "middle",
    fill: "rgba(255,253,248,0.92)",
    fontFamily: "Nunito, system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 700
  }, "Arriving soon")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoThumbPlaceholder);
export default __webpack_public_path__ + "static/media/video-thumb-placeholder.4d4e4d31adbb9316f312dc5e9cb78ffb.svg";
export { ForwardRef as ReactComponent };